module.exports = __webpack_public_path__ + "images/file_icons_v2/asp-10aa083720496a29be2c81cccac28a0b.svg";